import { InputHTMLAttributes } from "react";

interface RadioProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label: string;
  sizeText?: string;
}
export const Radio = ({ name, label, sizeText, ...rest }: RadioProps) => {
  return (
    <div className=" block h-[1rem] pl-[1.5rem] items-center">
      <input
        className="relative float-left -ml-[1.5rem]  mr-1 mt-[0.2rem] h-4 w-4 appearance-none rounded-sm border-2 border-solid border-neutral-300 before:pointer-events-none before:absolute before:h-4 before:w-4 before:scale-0 before:rounded-sm before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] before:content-[''] after:absolute after:z-[1] after:block after:h-3 after:w-3 after:rounded-sm after:content-[''] checked:border-primary checked:before:opacity-[0.16] checked:after:absolute checked:after:left-1/2 checked:after:top-1/2 checked:after:h-3/4 checked:after:w-3/4  checked:after:rounded-sm checked:after:border-primary checked:after:bg-primary checked:after:content-[''] checked:after:[transform:translate(-50%,-50%)] hover:cursor-pointer hover:before:opacity-[0.04] hover:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:shadow-none focus:outline-none focus:ring-0 focus:before:scale-100 "
        type="radio"
        name={name}
        id={label + name}
        {...rest}
      />
      <label
        className={`${sizeText ? sizeText : 'text-md'} text-gray-700 inline-block hover:cursor-pointer`}
        htmlFor={label + name}
      >
        {label}
      </label>
    </div>
  );
};
